import rjCard from "./rjCard"
export default rjCard;
